import { BASE_URL } from "../config/settings";
import httpRequest from "../utils/httpRequest";

export const initiateRemitaPayment = async (feePaymentId) => {
  return await httpRequest(
    `${BASE_URL}/v2/Payment/${feePaymentId}/generate-remita`,
    "post",
  );
};

export const confirmRemitaPayment = async (referenceId) => {
  return await httpRequest(
    `${BASE_URL}/v2/Payment/confirm-remita-payment/${referenceId}`,
    "post",
  );
};